
import { useStore } from "@/store";
import { computed, defineComponent, ref } from "vue";
import GoodItem from "./GoodItem.vue";
import { WsDTO } from "@/const/ws";
import { SysActionTypes } from "@/store/sys/action-types";
import { tradeType } from "@/const/trade";
import { confirm } from "@/util/confirm";
import { MutationTypes } from "@/store/player/mutation-types";
import { OptionsDataType } from "@/const/indexedDB";
import { SysInfo } from "@/const/sys";

const store = useStore();
export default defineComponent({
  name: "TabBox",
  components: {
    GoodItem
  },
  props: ["targetId"],
  setup(props: any) {
    const activeTab = ref("equipment");
    const packItemList = computed(() => {
      return store.state.userPackage;
    });
    const filterPackItemList = computed(() => {
      return packItemList.value.filter(m => {
        if (activeTab.value === "all") {
          return true;
        } else {
          return m.type === activeTab.value;
        }
      });
    });
    const giveMoney = ref(0);
    const userMoney = computed(() => {
      return store.state.userInfo.money;
    });
    const list: any[] = [];
    const choseList = ref(list);
    const playerListIds = computed(() => {
      return store.state.onlinePlayers.map(({ id }) => id);
    });
    const handleGive = async () => {
      const money = +giveMoney.value;
      if (!choseList.value.length && !money) return;
      const res = await confirm(
        "给予物品请保证操作过程中双方一直在线（如遇中途上下线需从玩家列表重新选择给予对象），丢失物品概不负责，是否给予？"
      );
      if (res) {
        const body = {
          tradeType: tradeType.GIVE,
          equipments: choseList.value,
          money
        };
        const data = new WsDTO(
          store.state.userInfo.userName,
          body,
          2,
          props.targetId
        ).ObjectToString();
        if (!playerListIds.value.includes(props.targetId)) {
          store.dispatch(
            SysActionTypes.SYS_PUSH_INFO,
            new SysInfo("对方已下线", 1)
          );
          return;
        }
        store.dispatch(SysActionTypes.SYS_WS_SEND, data);
        if (money) {
          store.commit(MutationTypes.MAKE_MONEY, -money);
          giveMoney.value = 0;
        }
        if (choseList.value.length) {
          choseList.value.forEach(async (m: any) => {
            store.commit(MutationTypes.REMOVE_ITEM_TO_PACKAGE, m.id);
            const params: OptionsDataType = {
              index: m.id
            };
            store.dispatch(SysActionTypes.SYS_DEL_EQUIP, params);
          });
          choseList.value = [];
        }
        store.dispatch(
          SysActionTypes.SYS_PUSH_INFO,
          new SysInfo("你要给的东西已经发过去了", 2)
        );
      }
    };
    const checkMoney = (v: number) => {
      if (v && v > userMoney.value) {
        giveMoney.value = userMoney.value;
      }
    };
    const handleChoose = (row: any) => {
      const index = choseList.value.findIndex(
        ({ id }: { id: number }) => id === row.id
      );
      if (index === -1) {
        choseList.value.push(row);
      } else {
        choseList.value.splice(index, 1);
      }
    };
    return {
      activeTab,
      packItemList,
      filterPackItemList,
      userMoney,
      choseList,
      handleGive,
      giveMoney,
      checkMoney,
      handleChoose,
      tabList: [
        // {
        //   key: "all",
        //   name: "全部"
        // },
        {
          key: "equipment",
          name: "装备栏"
        }
        // {
        //   key: "consumables",
        //   name: "消耗品"
        // }
      ]
    };
  }
});
